import i18n from '@/i18n/i18n';
import {EventData} from '@/types/event';
import {getJitsiConfig, getUserInfo, JITSI_MEET_SERVER} from './jitsi-config';
import {buildUrlParams} from './build-url-params';
import {UserInfosFormValues} from '@/redux-store/slices/user-infos';

export const openJitsiCall = (
  event: EventData,
  user: UserInfosFormValues,
  isUserManager: boolean
) => {
  const language = i18n.language;
  const baseUrl = `${JITSI_MEET_SERVER}/${event._id}?lang=${language}`;
  const userInfoParams = buildUrlParams(getUserInfo(user), {
    append: 'userInfo.'
  });
  const jitsiConfigParams = buildUrlParams(
    getJitsiConfig(event.title, isUserManager),
    {
      append: 'config.'
    }
  );

  const hashParams = `#${userInfoParams}&${jitsiConfigParams}`;

  const source = baseUrl + hashParams;

  window.open(source, '_blank', 'noopener, noreferrer');
};
